import React from 'react'
import { Link } from 'gatsby'

const AimFooterBottom = ({ type = 'default' }) => {
  return (
    <section className={`aimFooterBottom ${'aimFooterBottom--' + type}`}>
      <div className="aimFooterBottom__inner">
        <ul>
          <li>
            <Link to="/kojin-info">個人情報の取扱について</Link>
          </li>
          <li>
            <Link to="/privacy-policy">プライバシーポリシー</Link>
          </li>
          <li>
            <a href="https://mates-edu.co.jp">運営会社について</a>
          </li>
        </ul>
        <p>
          ©株式会社
          <wbr />
          メイツ
        </p>
      </div>
    </section>
  )
}

export default AimFooterBottom
